<template>
  <div class="genera">
    <barraNavegacionPublic class="barraNavegacionPublic"></barraNavegacionPublic>
    <cuerpo class="cuerpo"></cuerpo>
    <footerPublic class="footerPublic"></footerPublic>
  </div>
</template>

<script>
  import barraNavegacionPublic from './share/barraNavegacion';
  import cuerpo from './fragmentoContenido/cuerpo';
  import footerPublic from './share/footer';

  export default {
    name: "Contenido",
    components: {
      barraNavegacionPublic,
      cuerpo,
      footerPublic
    }
  }
</script>

<style scoped lang="scss">
  .genera {
    min-height: 100vh;
    background-color: #ffffff;
  }

  .barraNavegacionPublic {
    height: 8vh;
  }

  .cuerpo {
    min-height: 80vh;
    margin-bottom: 25px;
  }

  .footerPublic {
    height: 10vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/publico/contenido.vue